import { isEqual } from 'lodash';
import moment from 'moment';

export function dateComparer(prev: Date, next: Date): number {
  return moment(prev).diff(moment(next));
}

export function dateKeyComparer<T>(key: keyof T): (a: T, b: T) => number {
  return (prev: T, next: T) => moment(prev[key]).diff(moment(next[key]));
}

export function numberComparer(prev: number, next: number): number {
  return prev - next;
}

export function stringComparer(prev: string, next: string): number {
  // Handle null or undefined safely
  if (prev == null && next == null) return 0;
  if (prev == null) return -1;
  if (next == null) return 1;

  // Convert both to lowercase for case-insensitive sorting
  const a = prev.toLowerCase();
  const b = next.toLowerCase();

  // Use localeCompare for proper lexicographical sorting
  return a.localeCompare(b);
}

export function equalsCompare<T>(x: T | T[], y: T | T[]): boolean {
  return isEqual(x, y);
}
